<template>
  <div>
    <!-- kepala -->
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100% !important;
        top: 0px;
        right: 0px;
        left: 0px;
        z-index: 1;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div style="width: 100%" class="mt-4">
        <div class="image" align="center">
          <img src="../assets/img/Logo.png" width="50 px" height="50 px" />
        </div>
        <h3 style="white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;" class="text-center text-white ml-3 mr-3">Hi, {{ TeacherProfile.userName }}</h3>
        <p class="text-center text-white m-1">Welcome to pickiddo!</p>
        <br />
        <CCol sm="12">
          <span class="mt-5 mb-5"> </span>
          <br />
        </CCol>
      </div>
    </div>

    <!-- Buttons card -->
  
    <br /><br />
    <br /><br />
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
// Tell Vue to install the plugin.
export default {
  name: "Login",
  components: {},
  data() {
    return {
      backgroundBanner,
      TeacherProfile: {}
    };
  },
  async mounted() {
    this.GetTeacherProfile();
  },
  computed: {},
  methods: {
    async GetTeacherProfile() {
      this.$API
        .get(
          this.$TeacherProfile +
          "?userId=" +
          this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.TeacherProfile = response.data;
            console.log("TeacherProfile", this.TeacherProfile);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizTeacherDashboard?userId=" + this.$route.query.userId
      );
    },
    GoToTest() {
      this.$router.push(
        "/QuizTeacherTestOverview?userId=" + this.$route.query.userId
      );
    },
    GoToTeacherProfile() {
      this.$router.push(
        "/QuizTeacherProfile?userId=" + this.$route.query.userId
      );
    },
    GoToStatistic() {
      this.$router.push(
        "/QuizTeacherStatistic?userId=" + this.$route.query.userId
      );
    },
  },
};
</script>